// 倒计时模板
<template>
  <div class="hint"
    v-text="'页面关闭倒计时：'+ $store.state.mail_time + '秒'">
  </div>
</template>

<script>
import {
  countDown
} from '../../../../static/mailBox/js/request.js'

export default {
  name: 'countDown',
  props: ['time'],
  data () {
    return {
      // time: this.$store.state.time
    }
  },
  created () {
    // console.log('time', this.time)
    // 将页面传值的time赋给vuex
    this.$store.state.mail_time = this.time
    countDown(this.cancelBack)
  },
  mounted () {
  },
  methods: {
    // 返回首页
    cancelBack: function () {
      this.$store.state.mail_time = 10
      // return
      this.$router.push({
        // 你要跳转的地址
        path: '/mailBox'
      })
      this.$store.state.mail_index = 1
      this.$store.state.mail_type = ''
      this.$store.state.mail_oType = ''
      this.$store.state.mail_time= ''
      this.$store.state.mail_senderId= ''
      this.$store.state.mail_sendWay= ''
      this.$store.state.mail_deliver= {}
    }
  },
  watch: {
    // '$store.state.time': function (newVal) {
    //   this.time = newVal
    // }
  }
}

</script>

<style  scoped>
.hint{
  font-size: 15px;
  color: #ffffff;
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/common/countDown.vue